import axios from 'axios';
import * as yup from 'yup';
import { userSchema } from '~/schemas';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .object({
        users: yup.array(userSchema)
    })
});
export async function getUsersForPractice() {
    const url = '/api/profile/fetchUsers/';
    const response = await axios.get(url);
    const { data: { users } } = await responseSchema.validate(response.data);
    return {
        // @ts-ignore
        users,
    };
}
